<template>
  <div class="content">
    <div class="content-top">
       <div @click="toHistory" style="position: relative">
        <!-- <img src="../../../assets/image/new/left-top.png" style="position: absolute;top: 0;left: 0">
        <img src="../../../assets/image/new/left-center.png" style="position: absolute;top: 10px;left: -20px">
        <img src="../../../assets/image/new/right-center.png" style="position: absolute;bottom: 20px;right: 0">
        <img src="../../../assets/image/new/right-bottom.png" style="position: absolute;bottom: 0;right: 0"> -->
        <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/history.png">
        <div>
          <p class="number">{{total}}</p>
          <p class="person">历史记录</p>
        </div>
      </div>
      <div @click="toCountList(1)" style="position: relative">
        <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/yin.png">
        <div>
          <p class="number">{{negativeCount}}</p>
          <p class="person">核酸阴性</p>
        </div>
      </div>
      <div @click="toCountList(2)" style="position: relative">
          <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/yang.png">
          <div>
            <p class="number">{{positiveCount}}</p>
            <p class="person">核酸阳性</p>
          </div>
      </div>
      <div @click="toCountList(3)" style="position: relative">
         <img style="width:64px;height: 64px" src="../../../assets/image/newAnKang/noHeSuan.png">
          <div>
            <p class="number">{{noReportCount}}</p>
            <p class="person">无核酸报告</p>
          </div>
      </div>
    </div>
    <div class="content-bottom">
      <div class="title">近七天核酸报告统计</div>
      <div id="chart" style="height: 64vh;width: 88vw;"></div>
    </div>
  </div>
</template>

<script>
  import base from '../../../untils/base'
  import myHttp from '../../../untils/port'
  import util from '../../../untils/util'
  export default {
    data() {
      return {
        projectId: '',
        negativeCount: '',
        noReportCount: '',
        positiveCount: '',
        date: [],
        yangData: [],
        yinData: [],
        noData: [],
        total: 0
      }
    },
    created() {
       this.projectId = util.session.get('groupId')
       this.getCount()
       this.getData()
    },
    methods: {
      //获取数据
      getCount(){
        myHttp.findProjectPersonNucleicAcidStatistics({
          projectId: this.projectId
        }).then(resp => {
          if(resp.data.code === 200){
            console.log(resp);
            this.negativeCount = resp.data.data.projectPersonNucleicAcidStatistics.negativeCount || 0
            this.noReportCount = resp.data.data.projectPersonNucleicAcidStatistics.noReportCount || 0
            this.positiveCount = resp.data.data.projectPersonNucleicAcidStatistics.positiveCount || 0
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },
      getData(){
        myHttp.findRecentWeekProjectPersonNucleicAcidStatistics({
          projectId: this.projectId
        }).then(resp => {
          console.log(resp);
          if(resp.data.code === 200){
            const data = resp.data.data
            data.forEach(item => {
              this.date.push(item.date)
              this.yangData.push(item['阳性'])
              this.yinData.push(item['阴性'])
              this.noData.push(item['无核酸报告'])
            })
            let sum = 0
            sum += this.yangData.reduce((acc, cur) => {
              return acc + cur  
            })
            sum += this.yinData.reduce((acc, cur) => {
              return acc+ cur
            })
            sum += this.noData.reduce((acc, cur) => {
              return acc + cur
            })
            this.total = sum
            this.initChart()
          }else{
            this.$message.error(resp.data.msg)
          }
        })
      },

      initChart(){
        let chart = this.$echarts.init(document.querySelector('#chart'))
        chart.setOption({
          grid: {
            left: '10%',
            right: '5%'
          },
          xAxis: {
            boundaryGap: false,
            data: this.date,
          },
          yAxis: {},
          tooltip: {
            trigger: 'axis'
          },
          color: ['#0CCF93', '#F9693B ', '#7D7E7E '],
          series: [
            {
              name: '核酸阴性',
              type: 'line',
              smooth: true,
              data: this.yinData,
              // areaStyle: {
              //   opacity: 0.8,
              //   color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
              //     {
              //       offset: 0,
              //       color: 'rgb(128, 255, 165)'
              //     },
              //     {
              //       offset: 1,
              //       color: 'rgb(1, 191, 236)'
              //     }
              //   ])
              // },
            },
            {
              name: '核酸阳性',
              type: 'line',
              smooth: true,
              data: this.yangData
            },
            {
              name: '无核酸 ',
              type: 'line',
              smooth: true,
              data: this.noData
            }
          ]
        })
      },

      // 
      toHistory(){
        this.$router.push({
          path: '/heSuanHistory'
        })
      },

      // 去统计列表
      toCountList(flag){
        this.$router.push({
          path: '/newNucleinData',
          query: {
            flag: flag
          }
        })
      }
    },
  }
</script>

<style scoped>
.content-top{
  display: flex;
  justify-content: space-between;
}
.content-top > div {
  position: relative;
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 150px;
  width: 24%;
  border-radius: 6px;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
  padding: 0 3vw;
  cursor: pointer;
}
.content-bottom{
  border-radius: 6px;
  background: #FFFFFF;
  margin-top: 2vh;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.title{
  font-size: 18px;
  padding: 2vh 1vw;
  border-bottom: 2px solid #E7E7E7;
  text-align: left;
}
.content-top > div:nth-child(1){
  /* background: linear-gradient(290deg, #0D3A95 0%, #0D3A95 0%, rgba(89,126,240,0.00) 216%, rgba(89,126,240,0.00) 216%); */
  background: url('../../../assets/image/new/bg11.png') 55% 40%;
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-top > div:nth-child(2){
  background: url('../../../assets/image/new/bg22.png') 55% 40%;
  /* background: linear-gradient(290deg, #0CCF93 0%, #0CCF93 0%, rgba(89,126,240,0.00) 216%, rgba(89,126,240,0.00) 216%); */
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-top > div:nth-child(3){
  background: url('../../../assets/image/new/bg33.png') 55% 40%;
  /* background: linear-gradient(290deg, #F9693B 16%, #F9693B 16%, rgba(89,126,240,0.00) 195%, rgba(89,126,240,0.00) 201%); */
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.content-top > div:nth-child(4){
  background: url('../../../assets/image/new/bg44.png') 55% 40%;
  /* background: linear-gradient(285deg, #7D7E7E 0%, #7D7E7E 0%, rgba(115,123,147,0.00) 154%, rgba(115,123,147,0.00) 157%); */
  box-shadow: 0px 4px 10px 0px rgba(77, 110, 177, 0.3);
}
.number{
  font-size: 40px;
  color: #fff;
}
.person{
  font-size: 20px;
  color: #fff;
}
</style>